// extracted by mini-css-extract-plugin
module.exports = {"container":"InventoryModal_container__3C2xN","input":"InventoryModal_input__2L3sB"};